export default "__VITE_ASSET__BGjMsgz$__"